<nav id="topbar" role="navigation" class="navbar navbar-default navbar-fixed-top">
  <div class="navbar-header navbar-static-side logo-collapsed">
    <div class="frame-wrap-icon-menu float-left">
      <a [routerLink]="['/']" class="box-icon-menu float-left bg-icon-dashboard"></a>
    </div>
  </div>
  <div class="topbar-main flex">
    <div class="col-4 flex-1 h-full">
      <a id="logo-bavel" [routerLink]="['/']" class="navbar-left logo"></a>
    </div>
    <div class="col-4 flex-1 flex align-items-center justify-content-center h-full">
      <h3 class="text-center ellipsis title-section">
        <i [hidden]="!pageHeader.iconTitleSrc" class="fa {{pageHeader.faIcon}}"></i>
        <label translate>{{pageHeader.pageTitle}}</label>
      </h3>
    </div>
    <div class="col-4 flex-1 flex justify-content-end h-full">
      <!--BEGIN PANEL TOOLS USER-->
      <div class="boxTopbarConfig flex align-items-center">
        <div class="flex align-items-center dropdown">
          <div id="profile-btn" class="dropdown-toggle text-right">
            <p class="username mx-3 my-0 w-full" [hidden]="!loginName">{{loginName}}</p>
            <div class="w-full" (click)="op.toggle($event)">
              <span class="dropdown-toggle-text ">{{userProfile!.brandName}}</span>
              <i class="pi pi-angle-down" style="color: #0381FF"></i>
            </div>
          </div>
          <div>
            <p-popover #op>
              <div class="flex" style="width: 275px">
                <div class="w-3">
                  <img src="/assets/images/icons/profiles/icon-user-navbar-top.png" class="float-left" width="45"
                    height="45" />
                  </div>
                  <div class="w-9 ellipsis">
                    <span class="gray-light" translate>Web_EtiquetaUsuario</span><br>
                    <span class="gray-dark"><strong>{{userName}}</strong></span>
                  </div>
                </div>
                <div class="clear10"></div>
                <div class="flex" style="width: 275px">
                  <div class="w-3" style="margin-top: 7px;">
                    <img [src]="profileImgSrc" class="float-left" width="45" height="45" />
                  </div>
                  <div class="w-9 ellipsis">
                    <span class="gray-light">{{ userKindDisplay }}:</span><br>
                    <span class="gray-dark"><strong>{{userProfile!.brandName}}</strong></span><br>
                    <span class="blue-link">ID: {{userId}}</span>
                  </div>
                </div>
              </p-popover>

            <!--</popover-content> -->
            <img src="/assets/images/icons/profiles/user-blue.png" class="img-user hidden-sm" tabindex="0"
              (click)="op.toggle($event)" width="45" height="45" />

            </div>
          </div>
          <div>
            <a class="flex" (click)="goToPreferences()" style="cursor:pointer">
              <img class=" p-0 border-none bg-transparent" pButton src="/assets/images/icons/icon-settings.png" width="30"
                height="30" alt="{{'preferences_title' | translate}}" pTooltip="{{'preferences_title' | translate}}"
                tooltipPosition="bottom" />
              </a>
            </div>
            @if (false) {
              <div>
                <a href="#">
                  <img src="/assets/images/icons/icon-bell.png" width="30" height="30" alt="Notifications">
                </a>
              </div>
            }
            <div>
              <button type="button" class="btn bg-button-white ml-1 text-base font-medium" (click)="logout()">SIGN
              OUT</button>
            </div>
          </div>
        </div>
      </div>
    </nav>